export default "__VITE_ASSET__8bd1af58__"